<template>
    <ValidationProvider :name="name" :rules="field._validation" v-slot="validator">
        <b-field>
            <EvoLabel slot="label" :name="name" :field="field" :validator="validator"></EvoLabel>
            <b-datepicker :value="date" @input="inputDate" :show-week-number="true" icon="calendar-today" trap-focus :date-formatter="dateFormatter"></b-datepicker>
        </b-field>
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";

export default {
    mixins: [mixin],
    methods: {
        dateFormatter() {
            return DateTime.fromFormat(this.value, this.field._data_format).toFormat(this.field._display_format);
        },
        inputDate(date) {
            this.value = DateTime.fromJSDate(date).toFormat(this.field._data_format)
        },
    },
    computed: {
        date() {
            return DateTime.fromFormat(this.value, this.field._data_format).toJSDate();
        }
    },
    created() {
        if (!this.value) {
            this.value = DateTime.now().toFormat(this.field._data_format)
        }
    }
}
</script>
